'use client'

import { type FC, type ReactElement } from 'react'
import {
  type Control,
  Controller,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form'

import { BaseHookFormErrorMessage } from '../BaseHookFormErrorMessage/BaseHookFormErrorMessage'

import { type RadioParams } from './RadioGroupFieldset'
import { RadioInput } from './RadioInput'

type RadioGroupControllerProps = {
  className?: string
  containerClassName?: string
  control: Control
  legendMessage?: string
  name: keyof FieldValues
  radios: RadioParams[]
  rules?: UseControllerProps['rules']
}

export const RadioInputGroupHookFormController: FC<
  RadioGroupControllerProps
> = ({
  className,
  containerClassName,
  control,
  legendMessage,
  name,
  radios,
  rules,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }): ReactElement => {
        if (rules) {
          return (
            <div className={containerClassName}>
              <fieldset className={className}>
                <legend className="sr-only">{legendMessage}</legend>
                {radios.map((radio) => (
                  <RadioInput
                    name={name}
                    {...radio}
                    checked={value === radio.value}
                    key={radio.id}
                    onChange={onChange}
                  />
                ))}
              </fieldset>
              <BaseHookFormErrorMessage name={name} />
            </div>
          )
        }

        return (
          <fieldset className={className}>
            <legend className="sr-only">{legendMessage}</legend>
            {radios.map((radio) => (
              <RadioInput
                name={name}
                {...radio}
                checked={value === radio.value}
                key={radio.id}
                onChange={onChange}
              />
            ))}
          </fieldset>
        )
      }}
      rules={rules}
    />
  )
}
